<template>
  <div class="py-4 container-fluid">
    <h4 class="text-white">GENERAR TURNOS</h4>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-show="verbuscador">
              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Tipo de Documento</label>
                                    <select  v-model="tipodocumento" id="documento" name="documento" class="form-select">
                                      <option value="" disabled>Seleccionar</option>
                                       <option v-for="(item, index) in tiposdocumentos" :value="item.Codigo" :key="index">
                        {{ item.Nombre }}
                      </option>
                                      <!-- <option value="CC">Cedula de Ciudadania</option>
                                      <option value="TI">Tarjeta de Identidad</option>
                                      <option value="RC">Registro Civil</option> -->
                                    </select>
                                  </div>
              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Numero</label>
                <div class="form-group">
                  <input class="form-control" v-model="numerocedula" placeholder="Buscar por nombre" type="text"/>
                </div>
              </div>
              <div class="col-md-3 mt-4">
                <div class="form-group">
                  <div class="input-group input-group-merge">
                    <a
                      @click="buscarCedula(numerocedula)"
                      type="button"
                      class="btn btn-info"
                    >
                      Buscar
                      <i class="ni ni-world-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="visualizardatos" class="card-body">
            <div class="row">
               <div class="col-md-3">
                                   <label for="example-text-input" class="form-control-label"
                  >Tipo de Documento</label
                >
                                    <select disabled v-model="tipodocumento" id="documento" name="documento" class="form-select">
                                      <option value="" disabled>Seleccionar</option>
                                        <option v-for="(item, index) in tiposdocumentos" :value="item.Codigo" :key="index">
                        {{ item.Nombre }}
                      </option>
                                      <!-- <option value="CC">Cedula de Ciudadania</option>
                                      <option value="TI">Tarjeta de Identidad</option>
                                      <option value="RC">Registro Civil</option> -->
                                    </select>
                                  </div>
              <div class="col-md-3">
                <label for="example-text-input" class="form-control-label"
                  >Numero</label
                >
                <input
                  type="text"
                  class="form-control" disabled
                  v-model="numerocedula"
                  name="nombre"
                  id="nombre"
                />
              </div>
              <div class="col-md-3">
                <label for="example-text-input" class="form-control-label"
                  >Primer Nombre</label
                >
                <input
                  type="text"
                  class="form-control" :disabled="deshabilitarinput == 1"
                  v-model="datosclientepnombre"
                  name="nombre"
                  id="nombre"
                />
              </div>
              <div class="col-md-3">
                <label for="example-text-input" class="form-control-label"
                  >Primer Apellido</label
                >
                <input
                  type="text"
                  class="form-control" :disabled="deshabilitarinput == 1"
                  v-model="datosclientepapellido"
                  name="nombre"
                  id="nombre"
                />
              </div>
            </div>
            <!-- -------------------------------------------------------------------------- -->
            <div class="row card-header justify-content-center">
              <div v-for="(ser, index) in servicios" :key="index" class="col-lg-4 col-md-4 col-12 mb-2" style="cursor: pointer;">
                <a
                  @click="generarturno(numerocedula,ser.id,ser.inicial_servicio,ser.color)"
                  class="card border-0" :class="[ser.color]"
                >
                    <div class="card-body">
                      <div class="row">
                        <div class="col text-center">
                          <span class="h3 font-weight-bold mb-0 text-white"
                            >{{ser.nombre_servicio}}</span
                          >
                          <br />
                          <i class="coloriconos ni-5x" :class="[ser.icono]"></i>
                        </div>
                      </div>
                    </div>
                </a>
              </div>
            </div>

             <div class="text-center">
                    <a @click="limpiartodo()" type="button" class="btn btn-danger">
                      Atras
                    </a>
                </div>
            <!-- ------------------------------------------------------------------------------- -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tiposdocumentos from "../assets/json/tiposdocumentos.json";
import axios from "axios";
export default {
  name: "profile",
  data() {
    return {
      verbuscador: true,
      tipodocumento: "",
      numerocedula: "",
      datosclientepnombre: "",
      datosclientepapellido: "",
      servicios: "",
      visualizardatos: false,
      deshabilitarinput: 1,
      accion: 0,
       tiposdocumentos:tiposdocumentos,
    };
  },
  components: {},

  created: function () {
    this.servicios_activos();
  },
  methods: {
    servicios_activos() {
        axios.post("servicios_por_sede")
          .then((respuesta) => {
            this.servicios = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    buscarCedula(numerocedula) {
      this.servicios_activos();
      if (
        numerocedula == "" ||
        numerocedula == undefined ||
        numerocedula == null
      ) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Especificar un nombre o una cedula",
          "info"
        );
      } else if (
        numerocedula != "" ||
        numerocedula != undefined ||
        numerocedula != null
      ) {
         this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
        const tokenpeticion = {
          cedulaonombre: numerocedula,
        };
        axios
          .post("buscarclienteturno", tokenpeticion)
          .then((respuesta) => {
            console.log(respuesta.data.datos);
             this.$swal.close()
              this.verbuscador = false;
              this.visualizardatos = true;
            if (respuesta.data.codigo == 1) {
              this.accion = 1;
              this.deshabilitarinput = 0;
              this.$swal.fire(
                "Ups!!",
                "No se Encontraron datos con este Documento",
                "info"
              );
            } else {
              this.accion = 0;
              this.deshabilitarinput = 1;
              var datarespuesta = JSON.parse(respuesta.data.datos);
              this.tipodocumento = datarespuesta.documento;
              this.datosclientepnombre = datarespuesta.pnombre;
              this.datosclientepapellido = datarespuesta.papellido;
            }
          }).catch((error) => {
              if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
    generarturno(numerocedula, tipotramite,inicial,color) {
      if (
        this.tipodocumento == "" || this.tipodocumento == undefined || this.tipodocumento == null ||
        numerocedula == "" || numerocedula == undefined || numerocedula == null ||
        this.datosclientepnombre == "" || this.datosclientepnombre == undefined || this.datosclientepnombre == null ||
        this.datosclientepapellido == "" || this.datosclientepapellido == undefined || this.datosclientepapellido == null
      ) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Especificar un nombre o una cedula",
          "info"
        );
      } else if (
        numerocedula != "" ||
        numerocedula != undefined ||
        numerocedula != null
      ) {
        this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
        const tokenpeticion = {
          accion:this.accion,
          tipodocumento:this.tipodocumento,
          numero_doc: numerocedula,
          datosclientepnombre:this.datosclientepnombre,
          datosclientepapellido:this.datosclientepapellido,
          tipotramite: tipotramite,
          letrainicial: inicial,
        };
        axios
          .post("generarturno", tokenpeticion)
          .then((respuesta) => {
            this.$swal.close()
            this.limpiartodo();
            if (respuesta.data == "") {
              this.$swal.fire(
                "Ups!!",
                "No se Logro Generar el turno",
                "info"
              );
            } else {
             
              this.$swal.fire({
                icon: 'success',
                title: 'Turno Numero',
                html: '<div class="'+color+'">' +
                            '<span><h1 class="text-white">' + respuesta.data + '</h1></span>' +
                            '</div>',
            })
            }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
    limpiartodo(){
      this.verbuscador = true;
       this.deshabilitarinput = 1;
              this.accion = 0;
              this.visualizardatos = false;
              this.tipodocumento = "";
              this.numerocedula = "";
              this.datosclientepnombre = "";
              this.datosclientepapellido = "";
    }
  },
};
</script>
<style scoped>
.coloriconos {
  color: white;
}
</style>
